import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { FlavourComponent } from '../flavour/flavour.component';

@Component({
  selector: 'app-flavour-list',
  templateUrl: './flavour-list.component.html',
  styleUrls: ['./flavour-list.component.css']
})
export class FlavourListComponent implements OnInit {

  public menu_item_id = '71';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['flavour_name', 'flavour_name_en', 'main_item_name', 'flavour_price', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<FlavourComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'flavour', 'flavour_name': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['flavour_name'] != '')
      condition += " (`flavour_name` LIKE '%" + this.model['flavour_name'] +
        "%' OR `flavour_name_en` LIKE '%" + this.model['flavour_name'] + "% AND ";

    let query = "SELECT `flavour`.*, `main_item`.`main_item_name` FROM `flavour`, `main_item` WHERE " + condition
      + "`flavour`.`main_item_id` = `main_item`.`main_item_id` AND `flavour`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newFlavour() {
    this.addDialogRef = this.dialog.open(FlavourComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editFlavour(row) {
    let dialog_data = {
      'table_name': 'flavour', 'flavour_id': row.flavour_id,
      'main_item_id': row.main_item_id,
      'flavour_name': row.flavour_name,
      'flavour_name_en': row.flavour_name_en,
      'flavour_price': row.flavour_price,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(FlavourComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delFlavour(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'flavour_id': row.flavour_id }];
      //console.log(values);
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
